<router-outlet />

@if (pwaInstallService.shouldShowInstallDialog() && pwaInstallService.isIosSafari()) {
  <app-pwa-ios-install-banner />
}